import { Module } from '@/types/module.interfaces';
import { Injectable } from '@angular/core';
import { Router, Routes } from '@angular/router';
import { RouteRegistry } from './route-registry';

@Injectable({ providedIn: 'root' })
export class DynamicRouteService {

  constructor(private router: Router) {}

  loadDynamicRoutes(modules: Module[]) {
    const dynamicRoutes = this.buildDynamicRoutes(modules);
    const currentRoutes = this.router.config;
    const mainLayout = currentRoutes.find(route => route.path === '');

    if (!mainLayout || !mainLayout.children) {
      return;
    }

    mainLayout.children.push(...dynamicRoutes);
    this.router.resetConfig(currentRoutes);
  }

  private buildDynamicRoutes(modules: Module[]): Routes {
    const routes: Routes = [];
    if (!modules?.length) return routes;

    modules.forEach(module => {
      module.features?.forEach(feature => {
        const loader = RouteRegistry[feature.path];

        if (loader) {
          routes.push({
            path: feature.path.replace(/^\//, ""),
            title: feature.title,
            loadComponent: loader,
          });
        }
      });
    });

    return routes;
  }
}
